export const activateMessage =
    'By clicking "Activate Paid Plan", your free trial will end immediately, and you will be charged to activate all domains in your plan and start your paid subscription. \n If you do not wish to proceed to a paid subscription, click "Continue Trial"';
